import axios from 'axios';

const request = axios.create({
    baseURL: 'https://api.qiec.ca/',
});

export default request;
